"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ServerSideNetworkAdaption_1 = __importDefault(require("./ServerSideNetworkAdaption"));
/**
 * [[SignalingClientJoin]] contains settings for the Join SignalFrame.
 */
class SignalingClientJoin {
    /**
     * Initializes a SignalingClientJoin with the given properties.
     * @param applicationMetadata [[ApplicationMetadata]].
     */
    constructor(applicationMetadata) {
        this.applicationMetadata = applicationMetadata;
        this.serverSideNetworkAdaption = ServerSideNetworkAdaption_1.default.Default;
        this.supportedServerSideNetworkAdaptions = [];
        this.disablePeriodicKeyframeRequestOnContentSender = false;
    }
}
exports.default = SignalingClientJoin;
//# sourceMappingURL=SignalingClientJoin.js.map